/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

// @dynamic
@Injectable()
export class ContactInfoValidationService {
  public generalErrorKeys = [
    'required',
    'minlength',
    'maxlength',
    'pattern',
    'whitespace',
    'isExpiredCard',
    'amexonly',
    'uatponly'
  ];

  public errorMsgJson = {
    PAX_0031:
      "Whoops! We're sorry, please enter a valid email address to receive your confirmation,receipt and flight notifications.",
    PAX_0034:
      "Whoops! We're sorry, but the email address is invalid and must contain the @ symbol.",
    PAX_0075: "Whoops! We're sorry, please enter a valid Telephone number.",
    PAX_0076:
      "Whoops! We're sorry, but the telephone number entered is invalid. Please enter a minimum of 4 numbers"
  };

  // tslint:disable-next-line:member-ordering
  static getErrorMsgKey(validatorPropertyName: string, fieldName: string) {
    const errorMapConfig: any = CONTACT_INFO;
    const fieldNameErrorObj: any = errorMapConfig[fieldName];
    return fieldNameErrorObj[validatorPropertyName]; // FIRST_NAME_REQD
  }

  public getValidationErrors(formObject: any) {
    const validationErrorsArr: ValidationErrors[] = [];
    for (const f in formObject.controls) {
      if (formObject.controls.hasOwnProperty(f)) {
        if (formObject.controls[f].errors) {
          formObject.controls[f].markAsTouched();
          const errorObj: ValidationErrors = {
            fieldName: f,
            errorValue: formObject.controls[f].errors
          };
          validationErrorsArr.push(errorObj);
        }
      }
    }
    return validationErrorsArr;
  }

  getMessage(errorData: any, propertyName: string, formControlName: string) {
    const errorMessageKey = ContactInfoValidationService.getErrorMsgKey(
      propertyName,
      formControlName
    );
    if (errorData !== null && errorData !== undefined) {
      const errorObject: any = errorData.filter((errorObj: any) => {
        return errorObj.errorCode === errorMessageKey;
      });
      return errorObject[0].errorMessage;
    }
  }

  fetchErrorMsg(
    validationControl: AbstractControl,
    formControlName: string,
    errorData: any
  ) {
    for (const propertyName in validationControl.errors) {
      if (this.generalErrorKeys.indexOf(propertyName) > -1) {
        return this.getMessage(errorData, propertyName, formControlName);
      } else {
        return errorData[propertyName];
      }
    }

    return null;
  }
}

export const CONTACT_INFO = {
  phoneNumberCI: {
    required: 'PAX_0075',
    pattern: 'PAX_0076',
    minlength: 'PAX_0075'
  },
  emailCI: {
    required: 'PAX_0031',
    pattern: 'PAX_0034'
  }
};
